<script setup>
  import { useMediaQuery } from '@/composables/useMediaQuery';
  import SheetBackdrop from "@/components/SheetBackdrop.vue";
  import SheetInfo from "@/components/SheetInfo.vue";
  import SheetConfig from "@/components/SheetConfig.vue";
  import SheetSource from "@/components/SheetSource.vue";
  import SheetStorm from "@/components/SheetStorm.vue";

  const isDesktop = useMediaQuery('(min-width: 840px)');
</script>

<template>
  <Teleport to="body" :disabled="isDesktop">
    <div class="jwx-sheets-container">
      <SheetBackdrop />
      <SheetInfo position="primary" />
      <SheetConfig position="primary" />
      <SheetStorm position="primary" />
      <SheetSource position="secondary" />
    </div>
  </Teleport>
</template>